class BenefitChangedExpirationTypeSystemNotificationPayload {
  constructor(systemNotificationPayloadData = {}) {
    this.benefitName = systemNotificationPayloadData.benefit_name || "";
    this.oldType = systemNotificationPayloadData.old_type || "";
    this.newType = systemNotificationPayloadData.new_type || "";
  }
}

export default BenefitChangedExpirationTypeSystemNotificationPayload;
